import { Category } from '../types/category'
import { http } from '../services/http'
export const fetchCategories = async (): Promise<Array<Category>> => {
  const response = await http.get<Array<Category>>('/v2/admin/categories')
  return response.data
}
